module.exports = __webpack_public_path__ + "static/media/ceo.c310c33b.png";